import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GetFieldPipe } from "./get-field.pipe";
import { InitialsPipe } from "./initials.pipe";
import { SingleOptionPipe } from "./singleOption.pipe";

import { StringFormat } from "./stringFormat.pipe";

@NgModule({
  declarations: [
    StringFormat,
    InitialsPipe,
    GetFieldPipe,
    SingleOptionPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    StringFormat,
    InitialsPipe,
    GetFieldPipe,
    SingleOptionPipe,
  ],
})
export class MedPipesSharedModule { }
